import { TimerView } from "./TimerView";

export class TimerController {
	constructor() {
		this.interval = null;
		this.secondsRemain = null;
		this.view = new TimerView();
	}

	start(secondsRemain) {
		clearInterval(this.interval);
		this.secondsRemain = secondsRemain;
		this.interval = setInterval(() => {
			if (this.secondsRemain >= 0) {
				let seconds = Math.floor((this.secondsRemain / 1000) % 60);
				let minutes = Math.floor((this.secondsRemain / (1000 * 60)) % 60);
				let hours = Math.floor((this.secondsRemain / (1000 * 60 * 60)) % 24);
				this.view.show({ hours, minutes, seconds });
				this.secondsRemain = this.secondsRemain - 1000;
			} else {
				this.clear();
			}
		}, 1000);
	}

	clear() {
		clearInterval(this.interval);
		this.secondsRemain = null;
		this.view.hide();
	}
}
